export default function ExoText({ itemText }) {
  return (
    <li
      tabIndex="-1"
      className="lds-header-menu-item lds-header-menu-item-type-text"
    >
      <div className="lds-header-menu-item-content">
        <span
          className="lds-header-menu-item-text"
          dangerouslySetInnerHTML={{ __html: itemText }}
        />
      </div>
    </li>
  );
}
